import type { DrawerProps } from '@mantine/core';
import { Container, Drawer } from '@mantine/core';
import cs from 'classnames';
import type { Dispatch, FC, ReactNode, SetStateAction } from 'react';
import classes from './themeDrawer.module.scss';
interface IThemeDrawerProps extends Omit<DrawerProps, 'opened' | 'onClose'> {
  children: ReactNode;
  isOpen: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}
const ThemeDrawer: FC<IThemeDrawerProps> = ({
  children,
  isOpen,
  setOpen,
  ...props
}) => {
  const handleClose = () => {
    setOpen(false);
  };
  return <Drawer size="xs" withCloseButton={false} position="bottom" withOverlay overlayProps={{
    backgroundOpacity: 0.15,
    blur: 3
  }} classNames={{
    inner: cs(Container.classes.root, classes.root, 'z-[150] !max-w-[400px]'),
    content: '  overflow-visible  max-h-[400PX] h-fit  rounded-t-3xl bg-blueOne border-t-4 border-blackSeven ',
    body: 'pb-0',
    overlay: classes.overlay
  }} trapFocus={false} opened={isOpen} onClose={handleClose} {...props} data-sentry-element="Drawer" data-sentry-component="ThemeDrawer" data-sentry-source-file="ThemeDrawer.tsx">
      {children}
    </Drawer>;
};
export default ThemeDrawer;